import Cookies from "js-cookie";
import { ReactNode, createContext, useEffect, useState } from "react";
import useAuth from "../hook/useAuth";

const GroupContext = createContext({});

export const GroupProvider = ({ children }: { children: ReactNode }) => {
    const { auth }: any = useAuth();
    const role = Cookies.get("role-my-cdir") || "";
    const groupIdAuth = Cookies.get("groupId-my-cdir") || "";

    const [allGroups, setAllGroups] = useState<any[]>([]);
    const [selectedGroupId, setSelectedGroupId] = useState<number>(0);
    const [selectedTenantId, setSelectedTenantId] = useState("");
    const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);

    const resetTheState = () => {
        setAllGroups([]);
        setSelectedGroupId(0);
        setIsSuperAdmin(false);
    }

    useEffect(() => {
        if (auth === null) {
            resetTheState();
            return;
        }

        if (!role) return;

        if (role?.toString()?.toLowerCase()?.replaceAll(" ", "") === "superadmin") {
            setIsSuperAdmin(true);
        } else {
            if (!groupIdAuth) return;

            setIsSuperAdmin(false);
            setSelectedGroupId(parseInt(groupIdAuth));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, role, groupIdAuth])

    return (
        <GroupContext.Provider value={{ allGroups, setAllGroups, selectedGroupId, setSelectedGroupId, selectedTenantId, setSelectedTenantId, isSuperAdmin, setIsSuperAdmin }}>
            {children}
        </GroupContext.Provider>
    )
}

export default GroupContext;